export interface AuditLog {
  id: string
  actor: string
  actor_role: string
  action: string
  target_type: string
  target_id: string
  changes: {
    before: Record<string, unknown>
    after: Record<string, unknown>
  }
  ip_address?: string
  user_agent?: string
  timestamp: string
}

export interface AuditFilter {
  actor?: string
  action?: string
  target_type?: string
  target_id?: string
  from?: string
  to?: string
  page?: number
  limit?: number
}

export interface AuditLogsResponse {
  logs: AuditLog[]
  total: number
  page: number
  pages: number
}

export const AUDIT_ACTIONS = [
  'user.created',
  'user.updated',
  'user.suspended',
  'user.unsuspended',
  'user.password_reset',
  'user.quota_updated',
  'plan.created',
  'plan.updated',
  'plan.deleted',
  'package.created',
  'package.updated',
  'package.toggled',
  'coupon.created',
  'coupon.updated',
  'coupon.toggled',
  'coupon.deleted',
  'transaction.refunded',
  'config.updated',
  'login.success',
  'login.failed',
] as const

export const AUDIT_TARGETS = [
  'user',
  'plan',
  'package',
  'coupon',
  'transaction',
  'config',
  'auth',
] as const
